import React, { useEffect, useContext } from "react";
import { Box, Text, Button, Heading, Flex, Skeleton } from "@chakra-ui/react";
import { Formik, Form } from "formik";
import { OrdersContext } from "../Context/OrdersContext";
import CustomField from "../Common/Form/CustomField";
import { arrayToQuery, currencyFormatter } from "../../Utils/formatUtils";

const OrdersFilters = ({ statusOptions, filters, setFilters }) => {
  const { orders, getOrders, isLoadingOrders, latestQuery } =
    useContext(OrdersContext);

  const handleSubmit = (values) => {
    setFilters(values);
  };

  const sumTotalSales = () => {
    let total = 0;
    orders.map((sale) => {
      total += parseInt(sale.total);
    });
    return currencyFormatter(total);
  };

  useEffect(() => {
    let queries = {};

    if (filters?.statusId) {
      queries.statusId = arrayToQuery(filters.statusId);
      queries.name = filters.name;
      if (
        latestQuery.statusId !== queries.statusId ||
        latestQuery.name !== queries.name
      ) {
        getOrders(queries);
      }
    }
  }, [filters]);

  return (
    <Box w={"100%"}>
      <Box flex="1" textAlign="left">
        <Heading variant="h2">Filtros</Heading>
      </Box>

      <Formik
        initialValues={filters}
        enableReinitialize={true}
        onSubmit={(values, actions) => {
          handleSubmit(values);
          actions.setSubmitting(false);
        }}
      >
        {(props) => (
          <Form>
            <Flex
              spacing="50px"
              align="left"
              flexDirection={["column", "column", "row"]}
              justifyContent="space-around"
              gap={"0.75rem"}
            >
              <CustomField
                name="statusId"
                title="Estados"
                placeholder="Elija uno o más estados"
                inputType="select"
                props={props}
                multiSelect={true}
                options={statusOptions}
                customFontColor="menu.700"
              ></CustomField>

              <CustomField
                name="name"
                title="Buscador por cliente"
                placeholder="Ingrese un cliente"
                props={props}
                customFontColor="menu.700"
              ></CustomField>

              <Box align="center">
                <Button
                  mt={4}
                  colorScheme="teal"
                  isLoading={props.isSubmitting}
                  type="submit"
                >
                  Filtrar
                </Button>
              </Box>
            </Flex>
          </Form>
        )}
      </Formik>

      <Box
        mt="1.5rem"
        background="menu.200"
        padding="0.4rem"
        fontSize="0.9em"
        textAlign="center"
      >
        {isLoadingOrders ? (
          <Skeleton height="1.5rem" />
        ) : (
          <>
            La cantidad de pedidos es{" "}
            <Text as="span" fontSize="1.1em" color="text.500">
              {orders.length}
            </Text>{" "}
            por un total de
            <Text as="span" fontSize="1.1em" color="text.500">
              {" "}
              {sumTotalSales()}
            </Text>
            .
          </>
        )}
      </Box>
    </Box>
  );
};

export default OrdersFilters;
